import React from 'react'
import { SvgIcon } from '@mui/material'

export const ClockAlertIcon = () => (
  <SvgIcon
    viewBox="0 0 64 64"
    sx={{ height: '64px', width: '64px', color: 'white' }}
  >
    <path
      fill="#E6494F"
      d="M29.333 18.667v16L43.2 42.934l2.133-3.2-12-7.2V18.666h-4Zm24 13.333v16h5.334V32h-5.334Zm0 21.334v5.333h5.334v-5.334h-5.334Zm-5.333 0c-4.533 3.466-9.867 5.333-16 5.333-14.667 0-26.667-12-26.667-26.667 0-14.666 12-26.666 26.667-26.666 12.8 0 23.733 9.066 26.133 21.333h-5.6c-2.4-9.067-10.666-16-20.533-16-11.733 0-21.333 9.6-21.333 21.333 0 11.733 9.6 21.334 21.333 21.334 6.4 0 12-2.934 16-7.2v7.2Z"
    />
  </SvgIcon>
)
